/* src/app/notification-settings/notification-settings.component.scss */
.delivery-type {
  display: flex;
  column-gap: 1rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.notifications-to-receive {
  display: flex;
  column-gap: 1rem;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
}
.delivery-settings-grid,
.sort-locations-grid {
  display: grid;
  grid-template-columns: minmax(330px, max-content) minmax(330px, max-content);
  gap: 1rem;
  column-gap: 33px;
}
.delivery-settings-grid label,
.sort-locations-grid label {
  font-size: 14px;
  font-weight: 700;
}
.delivery-settings-grid .label-toggle-pair,
.sort-locations-grid .label-toggle-pair {
  display: flex;
  align-items: center;
  column-gap: 1.25rem;
}
.delivery-settings-grid .delivery-setting,
.sort-locations-grid .delivery-setting {
  display: flex;
  flex-flow: column;
  gap: 1rem;
}
.delivery-settings-grid .edit-email-link,
.sort-locations-grid .edit-email-link {
  padding-left: 10px;
}
a {
  text-decoration: underline;
}
::ng-deep .label-toggle-pair.error on-off-toggle {
  outline: 2px solid #C91A13;
  outline-offset: -1px;
  position: relative;
}
::ng-deep .label-toggle-pair.error on-off-toggle:after {
  font-family: upsicons, fantasy !important;
  content: "\e638" !important;
  color: #C91A13;
  position: absolute;
  top: calc(50% - 0.7em);
  right: -25px;
}
.sort-instructions {
  margin-top: -50px;
  width: 300px;
}
.location-sort {
  width: 300px;
  margin-top: 30px;
}
.location-sort .sort-controls {
  display: flex;
  flex-direction: row;
}
.location-sort .sort-controls ups-select {
  width: 275px;
}
.location-sort .up-and-down-sort {
  box-shadow: none;
  background-color: white;
  border: thin #757575 solid;
  margin-left: 10px;
}
.location-sort .up-and-down-sort:before {
  font-family: upsicons, fantasy !important;
  content: "\e619" !important;
}
/*# sourceMappingURL=notification-settings.component.css.map */
